export const FETCHING_LOGISTIC_TASKS = '@@toyota/FETCHING_LOGISTIC_TASKS';
export const FETCHED_LOGISTIC_TASKS = '@@toyota/FETCHED_LOGISTIC_TASKS';
export const FETCHED_LOGISTIC_TASKS_FAILED = '@@toyota/FETCHED_LOGISTIC_TASKS_FAILED';
export const UPDATING_LOGISTIC_TASKS = '@@toyota/UPDATING_LOGISTIC_TASKS';
export const UPDATED_LOGISTIC_TASKS = '@@toyota/UPDATED_LOGISTIC_TASKS';
export const UPDATED_LOGISTIC_TASKS_FAILED = '@@toyota/UPDATED_LOGISTIC_TASKS_FAILED';
export const CREATING_LOGISTIC_TASKS = '@@toyota/CREATING_LOGISTIC_TASKS';
export const CREATED_LOGISTIC_TASKS = '@@toyota/CREATED_LOGISTIC_TASKS';
export const CREATED_LOGISTIC_TASKS_FAILED = '@@toyota/CREATED_LOGISTIC_TASKS_FAILED';

